// BookingTypeEntryForm.js

import React from 'react';
import BookingTypeProvider from './bookingTypeProvider';
import BookingTypeEntryFormView from './bookingTypeEntryFormView';

const BookingTypeEntryForm = (props) => {
  return (
    <BookingTypeProvider {...props}>
      <BookingTypeEntryFormView />
    </BookingTypeProvider>
  );
};

export default BookingTypeEntryForm;
